import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step982103Meta extends BaseModel {
  /**
   * @param {boolean}
   */
  hasPension;

  /**
   * @param {boolean}
   */
  isVeteran;

  constructor(model = {}) {
    super();
    this.hasPension = model.hasPension;
    this.isVeteran = model.isVeteran;
  }
}
